import React from 'react';
import i18n from '../../../i18n/i18n';
import { Button, TextField, Grid, IconButton, Dialog, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import { wentWrong } from "../../../utils/ToastConfig";
import axios from '../../../utils/AxiosWrapper';
import 'react-toastify/dist/ReactToastify.css';
import Switch from '@material-ui/core/Switch';

export default class AddInstitutions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
            region: null, regions: [],
            title: null,
            link: null,
            opstine: [], opstina: null,
            aktivan: true,
            apliciranje: true,
            opis: null,
            type: null, types: [],
        }
    }

    componentDidMount() {
        // this.getByURL('region/filter_region', 'regions');
        let user = this.getUser();
        if (this.props.edit === true) {
            this.setState({
                region: user.id_region,
                title: this.props.data.naziv,
                opis: this.props.data.opis,
                aktivan: this.props.data.aktivan,
                apliciranje: this.props.data.apliciranje,
                opstina: this.props.data.id_opstina,
                type: this.props.data.id_vrsta_institucije,
            });
        }
        this.getByURL('field/filter_opstina_uslov', 'opstine', user.id_region, 'id_region');
        this.getByURL('institution/filter_institucija_vrsta', 'types', user.id_region, 'id_region');
    }

    getByURL(url, obj, event, required) {
        event = event || '';
        required = required || '';
        if (event != null) {
            axios.get(`api/${url}`, { params: { [required]: event } })
                .then(res => this.setState({ [obj]: res.data.data }))
                .catch(error => wentWrong('Something went wrong, please try again!'));
        }
    }
    getUser() {
        let user = localStorage.getItem('user');
        let userObject = JSON.parse(user);
        !user && window.location.replace(window.location.origin);
        return userObject;
    };

    addInstitution() {
        if (
            this.state.title &&
            // this.state.region &&
            this.state.opstina &&
            this.state.type
        ) {
            let data = {
                id: this.props.data.id,
                naziv: this.state.title,
                id_region: Number(this.state.region),
                id_opstina: Number(this.state.opstina),
                web_link: this.state.link,
                opis: this.state.opis,
                aktivan: this.state.aktivan,
                apliciranje: this.state.apliciranje,
                id_vrsta_institucije: this.state.type
            }

            axios.post('api/institution/create', { data: data })
                .then(res => {
                    this.props.handleClose();
                })
                .catch(error => {
                    wentWrong('Something went wrong, please try again!');
                    console.log(`Error: ${error}`);
                })
        }
        else wentWrong('Please enter all required fields!');
    }

    render() {
        return (
            <div style={{ padding: 20 }}>
                <Dialog open={this.props.add}
                    onClose={this.props.handleClose}
                    fullWidth={true}
                    disableBackdropClick
                    maxWidth="sm"
                    aria-labelledby="responsive-dialog-title">
                    <DialogTitle disableTypography={true} className="responsive-dialog-title">{this.props.edit ? i18n.t('Edit institution') : i18n.t('Add institution')}
                        <IconButton onClick={this.props.handleClose}>
                            <span className="icon-cancel-circle closeIcon" />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent>
                        <form id="add-layer">
                            <Grid container justify="space-between" alignContent="space-between" >

                                <Grid item xs={12}>
                                    <TextField required
                                        label={i18n.t('Title')}
                                        value={this.state.title}
                                        InputLabelProps={{ shrink: true }}
                                        style={{ width: '532px', marginBottom: '10px' }}
                                        onChange={(e) => { this.setState({ title: e.target.value }); }} >
                                    </TextField>
                                </Grid>

                                {/* <Grid item xs={6}>
                                    <TextField required
                                        label={i18n.t('Region')}
                                        select
                                        value={this.state.region}
                                        InputLabelProps={{ shrink: true }}
                                        SelectProps={{ native: true, }}
                                        style={{ width: '256px', marginBottom: '10px' }}
                                        onChange={(e) => {
                                            this.setState({ region: e.target.value, opstina: null, type: null });
                                            this.getByURL('field/filter_opstina_uslov', 'opstine', e.target.value, 'id_region');
                                            this.getByURL('institution/filter_institucija_vrsta', 'types', e.target.value, 'id_region');
                                        }} >
                                        <option value='' />
                                        {this.state.regions.map((regions) => <option key={regions.id} value={regions.id}>{regions.naziv}</option>)}
                                    </TextField>
                                </Grid> */}

                                <Grid item xs={6}>
                                    <TextField required
                                        label={i18n.t('State')}
                                        // disabled={!this.state.region}
                                        select
                                        value={this.state.opstina}
                                        InputLabelProps={{ shrink: true }}
                                        SelectProps={{ native: true, }}
                                        style={{ width: '256px', marginBottom: '10px' }}
                                        onChange={(e) => { this.setState({ opstina: e.target.value }); }}
                                    >
                                        <option value='' />
                                        {this.state.opstine.map((opstina) => <option key={opstina.id} value={opstina.id}>{opstina.naziv}</option>)}
                                    </TextField>
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField required
                                        label={i18n.t('Type of institution')}
                                        select
                                        value={this.state.type}
                                        InputLabelProps={{ shrink: true }}
                                        SelectProps={{ native: true, }}
                                        style={{ width: '256px', marginBottom: '10px' }}
                                        onChange={(e) => { this.setState({ type: e.target.value }); }}
                                    >
                                        <option value='' />
                                        {this.state.types.map((type) => <option key={type.id} value={type.id}>{type.naziv}</option>)}
                                    </TextField>
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        label={i18n.t('Web link')}
                                        value={this.state.link}
                                        InputLabelProps={{ shrink: true }}
                                        style={{ width: '532px', marginBottom: '10px' }}
                                        onChange={(e) => { this.setState({ link: e.target.value }); }} >
                                    </TextField>
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        multiline
                                        label={i18n.t('Description')}
                                        value={this.state.opis}
                                        inputProps={{ min: 0, style: { textAlign: 'justify' } }}
                                        InputLabelProps={{ shrink: true }}
                                        style={{ width: '532px', marginBottom: '10px' }}
                                        onChange={(e) => { this.setState({ opis: e.target.value }); }} >
                                    </TextField>
                                </Grid>

                                <Grid item container>
                                    <Typography>{i18n.t('Aplications')}</Typography>
                                    <Switch
                                        checked={this.state.apliciranje}
                                        color="primary"
                                        onChange={(e) => { this.setState({ apliciranje: !this.state.apliciranje }) }}
                                        name="apliciranje"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                </Grid>

                                <Grid item container>
                                    <Typography>{i18n.t('Active')}</Typography>
                                    <Switch
                                        checked={this.state.aktivan}
                                        color="primary"
                                        onChange={(e) => { this.setState({ aktivan: !this.state.aktivan }) }}
                                        name="aktivan"
                                        inputProps={{ 'aria-label': 'primary checkbox' }}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Button style={{ alignSelf: 'center', backgroundColor: '#58B4E5', color: 'white', marginTop: '20px', marginBottom: '10px' }}
                                        onClick={() => this.addInstitution()}
                                        disabled={this.props.layerPosting} >
                                        {this.props.edit ? i18n.t('Save') : i18n.t('Add')}
                                    </Button>
                                </Grid>

                                <Grid item xs={3}>
                                </Grid>
                            </Grid>
                        </form>
                    </DialogContent>
                </Dialog>
            </div>
        )
    }
};